import { getFormattedTime, debugWallet } from 'wallet-manager';
const trackUDSLoadTime = (ecommerce, udsInitializationTime, listingVin, listingId) => {
  const endTime = getFormattedTime();
  const timeDifference = (udsInitializationTime.raw - endTime.raw)?.toString()?.slice(1);
  if (window && window?.newrelic?.addPageAction) {
    window.newrelic.addPageAction('UDSLoadTime', {
      tenant: ecommerce,
      component: 'NativeDealCalculator',
      message: 'To measure UDS Load Time',
      url: window.location.href,
      initializationTime: udsInitializationTime.formatted,
      udsLoadedAt: endTime.formatted,
      timeLaps: timeDifference,
      vin: listingVin,
      listingId
    });
  }
  if (ecommerce) {
    debugWallet('UDS', `Time metrics - UDSInitializationTime: ${udsInitializationTime.formatted}, UDSLoadedAt: ${endTime.formatted}, timeLaps: ${timeDifference}`);
  }
};
export { trackUDSLoadTime as default };
